

export default function Badge( { children, className }: { children: React.ReactNode, className?: string } ) {
    return (
        <span className={`badge bg-gold-soft text-xs rounded-lg py-1 shadow-lg hover:bg-gold-soft/50 cursor-pointer  transition-all    duration-300    shadow-gold-vibrant/30 px-3 ${className}`}>
        {children}
        </span>
    )
    }